import { render, staticRenderFns } from "./InnSwitch.vue?vue&type=template&id=43668325&"
import script from "./InnSwitch.vue?vue&type=script&lang=js&"
export * from "./InnSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports